// extracted by mini-css-extract-plugin
export default {"hint":"ViewFullscreenHint_hint__-GN++","hintVisible":"ViewFullscreenHint_hintVisible__DADz6","escKey":"ViewFullscreenHint_escKey__z6z5n"};